/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_End_LabelInputs */



/**
* | output |
* | --- |
* | "End" |
*
* @param {Video_Export_Segment_End_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_end_label = /** @type {((inputs?: Video_Export_Segment_End_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_End_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ende")
	if (locale === "it") return /** @type {LocalizedString} */ ("FINE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конец")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结尾")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終わり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fim")
	return /** @type {LocalizedString} */ ("End")
});